/**
 * Form response messages
 */
export default class Message {

    constructor(message = null, type = null) {
        this.setEventListeners();
        if (!message || !type) { return false; }
        this.createMessage(message, type);
    }

    setEventListeners() {
        $(document).on('click', '.close-message', () => this.removeMessage());
    }

    /**
     * Show message
     */
    createMessage(message, type) {
        $('.response-message').remove();
        let elm = $('<div class="response-message"></div>');
        let self = this;
        let html = `
            <div class="form-response ${type}">
                <div class="response-content">
                    ${message}
                </div>
                <span class="close-message"></span>
            </div>
        `;
        elm.html(html);
        $('body').append(elm);
        setTimeout(() => {
            self.removeMessage();
    }, 10000);
    }

    /**
     * Remove message
     */
    removeMessage() {
        console.log('removing message');
        let response = $(document).find('.form-response');
        response.fadeOut(200);
        setTimeout(() => {
            response.remove();
    }, 202);
    }


}


// WEBPACK FOOTER //
// ./resources/assets/js/Message.js